function requestBuildUnitStyle(style, propertyName, propertyValue) {
  if (typeof propertyValue !== "undefined")
    style = buildUnitStyle(style, propertyName, propertyValue);
  return style;
}
function buildUnitStyle(style, propertyName, propertyValue) {
  if (!Number.isNaN(Number(propertyValue))) {
    style[propertyName] = `${propertyValue}px`;
  } else {
    if (typeof style !== "undefined") {
      if (propertyValue)
        style[propertyName] = propertyValue;
      else
        delete style[propertyName];
    }
  }
  return style;
}
function buildColorStyles(styles, settings) {
  if (typeof settings.color !== "undefined")
    styles.color = settings.color;
  if (typeof settings.backgroundColor !== "undefined")
    styles.backgroundColor = settings.backgroundColor;
  return styles;
}
function buildPaddingStyles(styles, settings) {
  if (typeof settings.padding !== "undefined") {
    if (typeof settings.padding.top !== "undefined") {
      const paddingTop = settings.padding.top;
      if (!Number.isNaN(Number(paddingTop)) && Number(paddingTop) < 0 || typeof paddingTop === "string" && paddingTop[0] === "-") {
        delete styles.paddingTop;
      } else {
        styles = requestBuildUnitStyle(
          styles,
          "paddingTop",
          settings.padding.top?.toString()
        );
      }
    }
    if (typeof settings.padding.bottom !== "undefined") {
      const paddingBottom = settings.padding.bottom;
      if (!Number.isNaN(Number(paddingBottom)) && Number(paddingBottom) < 0 || typeof paddingBottom === "string" && paddingBottom[0] === "-") {
        delete styles.paddingBottom;
      } else {
        styles = requestBuildUnitStyle(
          styles,
          "paddingBottom",
          settings.padding.bottom?.toString()
        );
      }
    }
    if (typeof settings.padding.left !== "undefined") {
      const paddingLeft = settings.padding.left;
      if (!Number.isNaN(Number(paddingLeft)) && Number(paddingLeft) < 0 || typeof paddingLeft === "string" && paddingLeft[0] === "-") {
        delete styles.paddingLeft;
      } else {
        styles = requestBuildUnitStyle(
          styles,
          "paddingLeft",
          settings.padding.left?.toString()
        );
      }
    }
    if (typeof settings.padding.right !== "undefined") {
      const paddingRight = settings.padding.right;
      if (!Number.isNaN(Number(paddingRight)) && Number(paddingRight) < 0 || typeof paddingRight === "string" && paddingRight[0] === "-") {
        delete styles.paddingRight;
      } else {
        styles = requestBuildUnitStyle(
          styles,
          "paddingRight",
          settings.padding.right?.toString()
        );
      }
    }
  }
  return styles;
}
function buildMarginStyles(styles, settings) {
  if (typeof settings.margin !== "undefined") {
    if (typeof settings.margin.top !== "undefined") {
      styles = requestBuildUnitStyle(
        styles,
        "marginTop",
        settings.margin.top?.toString()
      );
    }
    if (typeof settings.margin.bottom !== "undefined") {
      styles = requestBuildUnitStyle(
        styles,
        "marginBottom",
        settings.margin.bottom?.toString()
      );
    }
    if (typeof settings.margin.left !== "undefined") {
      styles = requestBuildUnitStyle(
        styles,
        "marginLeft",
        settings.margin.left?.toString()
      );
    }
    if (typeof settings.margin.right !== "undefined") {
      styles = requestBuildUnitStyle(
        styles,
        "marginRight",
        settings.margin.right?.toString()
      );
    }
  }
  return styles;
}
function buildFlexStyles(styles, breakpointSettings) {
  if (breakpointSettings.displayMode === "flex" && breakpointSettings.flex) {
    if (typeof styles === "undefined")
      styles = {};
    styles.flexDirection = typeof breakpointSettings.flex.direction !== "undefined" ? breakpointSettings.flex.direction : "row";
    styles.flexWrap = typeof breakpointSettings.flex.wrap !== "undefined" ? breakpointSettings.flex.wrap : "nowrap";
    styles.justifyContent = typeof breakpointSettings.flex.justify !== "undefined" ? breakpointSettings.flex.justify : "flex-start";
    styles.alignItems = typeof breakpointSettings.flex.align !== "undefined" ? breakpointSettings.flex.align : "stretch";
  }
  return styles;
}
function buildGridStyles(styles, breakpointSettings) {
  if (breakpointSettings.displayMode === "grid" && breakpointSettings.grid) {
    if (typeof styles === "undefined")
      styles = {};
    styles.columns = typeof breakpointSettings.grid.columns !== "undefined" ? breakpointSettings.grid.columns.toString() : "1";
    styles.gridTemplateColumns = `repeat(${styles.columns}, minmax(0, ${styles.columns}fr))`;
    if (breakpointSettings.grid.unifiedGap) {
      styles = requestBuildUnitStyle(
        styles,
        "gap",
        breakpointSettings.grid.gap?.toString()
      );
    } else {
      styles = requestBuildUnitStyle(
        styles,
        "columnGap",
        breakpointSettings.grid.gapX?.toString()
      );
      styles = requestBuildUnitStyle(
        styles,
        "rowGap",
        breakpointSettings.grid.gapY?.toString()
      );
    }
  }
  return styles;
}
function buildMaxWidthStyles(styles, breakpointSettings) {
  if (typeof breakpointSettings.maxWidth !== "undefined" && breakpointSettings.maxWidth !== null) {
    styles = requestBuildUnitStyle(
      styles,
      "maxWidth",
      breakpointSettings.maxWidth.toString()
    );
  }
  return styles;
}
export {
  buildColorStyles,
  buildFlexStyles,
  buildGridStyles,
  buildMarginStyles,
  buildMaxWidthStyles,
  buildPaddingStyles,
  buildUnitStyle,
  requestBuildUnitStyle
};
